import { render, staticRenderFns } from "./InstitutionEdit.vue?vue&type=template&id=784ca31a&"
import script from "./InstitutionEdit.vue?vue&type=script&lang=js&"
export * from "./InstitutionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports